import { BaseException } from '@/domain/exceptions/baseException.ts'

export class TenantIsNotActiveException extends BaseException {
  constructor() {
    super('Tenant is not active')
  }
}
